<form [formGroup]="form">
  <div class="form-row">
    <div class="form-group col-12 col-md-6">
      <label>Mensaje para financiador</label>
      <input type="text" class="form-control" formControlName="mensajeFinanciador"
        placeholder="Mensaje para financiador">
    </div>
  </div>
</form>
